import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { Page } from "../../Page";
import { addFeedbackAsync, setFeedback, selectFeedbackBody, selectOkToSend } from "./feedBackSlice";
import { useAuth0 } from "@auth0/auth0-react"
import styles from './feedback.module.css'
import { useEffect } from "react";
import { setHomeButtonVisible, setReloadButtonVisible } from "../menu/menuSlice";
import { BackButton } from "../menu/BackButton";

export function FeedBack() {
    const feedbackBody = useAppSelector(selectFeedbackBody)
    const okToSend = useAppSelector(selectOkToSend)
    const dispatch = useAppDispatch()
    const navigate = useNavigate()
    const { isAuthenticated, getAccessTokenSilently, user } = useAuth0()

    useEffect(() => {
      dispatch(setReloadButtonVisible(true))
      dispatch(setHomeButtonVisible(true))
    })
    return(
        <Page>
          <div className={styles.bannerContainer}>
            <div>
                <h2>PartyPlanner.</h2>
                    <h4>Organise, invite and celebrate in style.</h4>
            </div>
            <div className={styles.bannerButton}>
                <BackButton/>
            </div>
          </div>
          {isAuthenticated? 
          <div className={styles.content}>
            <h2>FeedBack</h2> <br></br>
            <label>Please write your feedback here</label>
            <br></br>
            <input type="text" 
              value={feedbackBody}
              onChange = {(e) => {
              dispatch(setFeedback(e.target.value))
            }}></input>
            <br></br>
            <br></br>
            <button className={styles.button} disabled = {!okToSend}
               onClick ={async () => {
              if ( isAuthenticated && user?.email ) { 
              const accessToken = await getAccessTokenSilently({ authorizationParams : {
              }})
              dispatch(addFeedbackAsync( {
                  token: accessToken,
                  email: user?.email,

              }))}
              alert('Feedback successful')
              navigate(-1)
            }}>Save</button>
          </div>
          :
          <div><h3>Must be logged in to give feedback</h3></div>}
        </Page>
    )
}